import script from "./sf-accordion-item.ce.vue?vue&type=script&lang=ts&setup=true"
export * from "./sf-accordion-item.ce.vue?vue&type=script&lang=ts&setup=true"

import _style_0 from "./sf-accordion-item.ce.vue?vue&type=style&index=0&id=db392213&inline&lang=scss"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['styles',[_style_0]]])

export default __exports__